export default function ItemIconLoading() {
  return <div className="size-5 rounded-base bg-sidebar" />;
}
